// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de la pestanya "Control Horari" d'un Empleat
   (Gestió laboral / Empleats -> Gestió -> Control Horari).

   Fàcil de revertir: si no agrada, n'hi ha prou de treure la classe
   "ch-emp" del contenidor i aquest fitxer queda sense efecte. */

/* Omple tot l'espai disponible dins de ".gestioempleat-content-flex" (veure
   gestioempleat.css) i deixa que sigui NOMÉS ".Dashboard-table-container" qui
   faci scroll (flex: 1 en comptes del "max-height: calc(100vh - ...)" fix de
   dashboard.css, que assumia estar just sota les pestanyes, no sota un
   navegador de mes + aquesta pestanya de subnivell). */
.ch-emp {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  height: 100%;
  min-height: 0;
}

.ch-emp .Dashboard-table-container {
  flex: 1 1;
  max-height: none;
  min-height: 0;
}

.ch-emp-nav {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex: 0 0 auto;
}

.ch-emp-titol-mes {
  font-weight: bold;
  min-width: 140px;
  text-align: center;
}

.ch-emp-error {
  color: #c0392b;
}

.ch-emp-xip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  margin: 1px 3px 1px 0;
  white-space: nowrap;
}

.ch-emp-xip-no-laborable {
  background-color: #b0bec5;
}

.ch-emp-desviacio-pos {
  color: #2e7d32;
  font-weight: bold;
}

.ch-emp-desviacio-neg {
  color: #c0392b;
  font-weight: bold;
}

.ch-emp .Dashboard-table tbody td:has(.ch-emp-detall) {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.ch-emp-detall {
  padding: 10px 6px;
  background-color: #fafafa;
  white-space: normal;
}

.ch-emp-events-taula {
  margin-bottom: 10px;
}

.ch-emp .Dashboard-btn {
  width: auto;
  min-width: 0;
  white-space: nowrap;
}

.ch-emp .Dashboard-button-group {
  flex-wrap: wrap;
  margin-top: 10px;
}

.ch-emp-btn-petit {
  padding: 2px 8px;
  font-size: 12px;
}

.ch-emp .Dashboard-table tbody tr.ch-emp-avui {
  background-color: #ffe08a;
}

.ch-emp .Dashboard-table tbody tr.ch-emp-avui:hover {
  background-color: #ffd666;
}

.ch-emp-avui-marca {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: #e67e22;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  vertical-align: middle;
}

.ch-emp-accions-event {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.ch-emp-btn-esborrar {
  background-color: #c0392b;
  color: #fff;
}

.ch-emp-form {
  margin-top: 10px;
}

.ch-emp-esborrany-avis {
  margin: 0 0 10px;
  color: #8a6d3b;
  font-size: 13px;
}

.ch-emp-confirmar {
  margin-bottom: 10px;
  padding: 8px 10px;
  background: #fff8e1;
  border: 1px solid #f0e0a0;
}

.ch-emp-events-taula input[type="datetime-local"],
.ch-emp-events-taula select {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/controlhorariempleat.css"],"names":[],"mappings":"AAAA;;;;gEAIgE;;AAEhE;;;;uDAIuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB","sourcesContent":["/* Estils específics de la pestanya \"Control Horari\" d'un Empleat\n   (Gestió laboral / Empleats -> Gestió -> Control Horari).\n\n   Fàcil de revertir: si no agrada, n'hi ha prou de treure la classe\n   \"ch-emp\" del contenidor i aquest fitxer queda sense efecte. */\n\n/* Omple tot l'espai disponible dins de \".gestioempleat-content-flex\" (veure\n   gestioempleat.css) i deixa que sigui NOMÉS \".Dashboard-table-container\" qui\n   faci scroll (flex: 1 en comptes del \"max-height: calc(100vh - ...)\" fix de\n   dashboard.css, que assumia estar just sota les pestanyes, no sota un\n   navegador de mes + aquesta pestanya de subnivell). */\n.ch-emp {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  min-height: 0;\n}\n\n.ch-emp .Dashboard-table-container {\n  flex: 1;\n  max-height: none;\n  min-height: 0;\n}\n\n.ch-emp-nav {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  flex: 0 0 auto;\n}\n\n.ch-emp-titol-mes {\n  font-weight: bold;\n  min-width: 140px;\n  text-align: center;\n}\n\n.ch-emp-error {\n  color: #c0392b;\n}\n\n.ch-emp-xip {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 12px;\n  margin: 1px 3px 1px 0;\n  white-space: nowrap;\n}\n\n.ch-emp-xip-no-laborable {\n  background-color: #b0bec5;\n}\n\n.ch-emp-desviacio-pos {\n  color: #2e7d32;\n  font-weight: bold;\n}\n\n.ch-emp-desviacio-neg {\n  color: #c0392b;\n  font-weight: bold;\n}\n\n.ch-emp .Dashboard-table tbody td:has(.ch-emp-detall) {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.ch-emp-detall {\n  padding: 10px 6px;\n  background-color: #fafafa;\n  white-space: normal;\n}\n\n.ch-emp-events-taula {\n  margin-bottom: 10px;\n}\n\n.ch-emp .Dashboard-btn {\n  width: auto;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.ch-emp .Dashboard-button-group {\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.ch-emp-btn-petit {\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.ch-emp .Dashboard-table tbody tr.ch-emp-avui {\n  background-color: #ffe08a;\n}\n\n.ch-emp .Dashboard-table tbody tr.ch-emp-avui:hover {\n  background-color: #ffd666;\n}\n\n.ch-emp-avui-marca {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 1px 6px;\n  border-radius: 8px;\n  background-color: #e67e22;\n  color: #fff;\n  font-size: 11px;\n  font-weight: bold;\n  vertical-align: middle;\n}\n\n.ch-emp-accions-event {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.ch-emp-btn-esborrar {\n  background-color: #c0392b;\n  color: #fff;\n}\n\n.ch-emp-form {\n  margin-top: 10px;\n}\n\n.ch-emp-esborrany-avis {\n  margin: 0 0 10px;\n  color: #8a6d3b;\n  font-size: 13px;\n}\n\n.ch-emp-confirmar {\n  margin-bottom: 10px;\n  padding: 8px 10px;\n  background: #fff8e1;\n  border: 1px solid #f0e0a0;\n}\n\n.ch-emp-events-taula input[type=\"datetime-local\"],\n.ch-emp-events-taula select {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
